import { DAY_OF_WEEK } from 'app/typings/core/common/enum/dayOfWeek';
import type { DayOfWeek } from 'app/typings/core/common/enum/dayOfWeek';

import type { DefaultDiscountMode } from './RoomDiscount/hooks/useRoomDiscountLogic';

type DefaultNightRoomDiscountValues = {
  isDefaultDiscountEnabled?: boolean;
  defaultDiscountMode: DefaultDiscountMode;
  defaultNightRoomDiscount?: number | null;
  defaultNightRoomDiscountDays?: Partial<Record<DayOfWeek, number>> | null;
};

export const buildDefaultNightRoomDiscount = ({
  isDefaultDiscountEnabled,
  defaultDiscountMode,
  defaultNightRoomDiscount,
  defaultNightRoomDiscountDays,
}: DefaultNightRoomDiscountValues) => {
  if (isDefaultDiscountEnabled !== true) {
    return null;
  }

  const dailyDays = Object.values(DAY_OF_WEEK).reduce(
    (acc, day) => {
      acc[day] = (defaultNightRoomDiscountDays?.[day] ?? 0) / 100;

      return acc;
    },
    {} as Record<DayOfWeek, number>
  );

  const dailyRates = Object.values(dailyDays);

  const isUniformDaily = dailyRates.every((rate) => rate === dailyRates[0]);

  return defaultDiscountMode === 'DAILY' && !isUniformDaily
    ? {
        type: 'DAILY' as const,
        days: dailyDays,
      }
    : {
        type: 'CONSTANT' as const,
        rate:
          defaultDiscountMode === 'DAILY'
            ? (dailyRates[0] ?? 0)
            : (defaultNightRoomDiscount ?? 0) / 100,
      };
};
